export enum OrderIdPrefix {
  EMPTY = "",
  SWAP = "9"
}
